/**
 * LastUpdated - 最終更新日時表示コンポーネント
 * 
 * @param {{ updatedAt: Date|null }} props
 */
const LastUpdated = ({ updatedAt }) => {
  if (!updatedAt) return null;

  const month = updatedAt.toLocaleDateString('ja-JP', { month: 'numeric', day: 'numeric' });
  const time = updatedAt.toLocaleTimeString('ja-JP', { hour: '2-digit', minute: '2-digit' });

  return (
    <div className="flex justify-center mt-4 px-4">
      <p
        className="w-full text-white text-xl font-bold py-3 rounded-lg text-center"
        style={{ backgroundColor: '#950100' }}
      >
        {month} {time}現在
      </p>
    </div>
  );
};

export default LastUpdated;
